import { Link } from "react-router-dom";
import { ArrowRight, ChartLineUp, ShieldCheck, Lightning, MapPin } from "@phosphor-icons/react";
import useSEO from "@/hooks/useSEO";
import { PageHeader } from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import useT from "@/i18n";
import { breadcrumbLd, webPageLd } from "@/lib/seo";

const ICONS = [Lightning, ShieldCheck, ChartLineUp, MapPin];

export default function About() {
  const { t: T, lp } = useT();
  const t = T.about;
  const path = "/about";
  const title = t.seoTitle;
  const description = t.seoDesc;
  const crumbs = [{ name: t.crumb, path }];
  useSEO({ title, description, path, jsonLd: [webPageLd({ title, description, path: lp(path) }), breadcrumbLd(crumbs, T.crumbs.home, lp)] });

  return (
    <div data-testid="about-page">
      <PageHeader crumbs={crumbs} badge={t.badge} title={t.title} intro={t.intro} />
      <section className="max-w-7xl mx-auto safe-x sm:px-8 pb-16" aria-labelledby="values-heading">
        <h2 id="values-heading" className="font-display text-3xl sm:text-4xl font-bold tracking-tight">{t.valuesTitle}</h2>
        <div className="mt-8 grid sm:grid-cols-2 gap-5">
          {t.values.map(([vt, vd], i) => { const Icon = ICONS[i]; return (
            <Reveal key={vt} delay={i * 0.06}>
              <article className="glass rounded-2xl p-7 h-full">
                <Icon size={28} weight="duotone" className="text-[#00BFFF]" aria-hidden="true" />
                <h3 className="font-display text-lg font-semibold mt-4">{vt}</h3>
                <p className="text-sm text-slate-400 mt-2 leading-relaxed">{vd}</p>
              </article>
            </Reveal>
          ); })}
        </div>
        <div className="mt-12 glass rounded-3xl p-7 sm:p-10 glow-cyan-sm flex flex-col md:flex-row md:items-center justify-between gap-6">
          <div>
            <h2 className="font-display text-2xl sm:text-3xl font-bold">{t.ctaTitle}</h2>
            <p className="text-slate-400 mt-2">{t.ctaText}</p>
          </div>
          <Link to={lp("/download")} className="btn-primary" data-testid="about-download-cta">{t.cta} <ArrowRight size={16} aria-hidden="true" /></Link>
        </div>
      </section>
    </div>
  );
}
